import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import last from 'lodash/last';
import moment from 'moment-timezone';

import { ScheduleType } from 'src/models/Ivrs/Nodes/ScheduleNodeDef';
import { STORED_DATETIME_FORMAT } from 'src/presentation/components/pages/shared/constants/dateTimeConstants';

export const getTimeRangeForTemporarySplitNode = schedules => {
  if (isEmpty(schedules)) {
    return {
      isActive: false,
      isNew: true,
      start: '',
      end: '',
      durationInMinutes: '30',
      nextId: '',
      location: moment.tz.guess(),
    } as any;
  }

  const type = get(schedules, '0.schedule.type') as ScheduleType;
  const base = '0.schedule.schedule';
  const nextId = schedules[0].nodeId;
  const timezone = get(schedules, `${base}.location`);

  const isIndefinitely = type === ScheduleType.SCHEDULE_TYPE_WEEKDAY;

  if (isIndefinitely) {
    return { isActive: true, isNew: false, durationInMinutes: 'Indefinitely', nextId, location: timezone };
  }

  const startDate = get(schedules, `${base}.date`);
  const endDate = get(last(schedules), 'schedule.schedule.date');

  const timeRangeKey = 'schedule.schedule.timeRanges[0]';

  const startTime = get(schedules, `0.${timeRangeKey}.start`);
  const endTime = get(last(schedules), `${timeRangeKey}.end`);

  const start = moment.tz(`${startDate} ${startTime}`, STORED_DATETIME_FORMAT, timezone);
  const end = moment.tz(`${endDate} ${endTime}`, STORED_DATETIME_FORMAT, timezone);

  const durationInMinutes = moment.duration(end.diff(start)).asMinutes().toString();
  const current = moment().tz(timezone);
  const isActive = current.isBetween(start, end);

  return {
    durationInMinutes,
    end,
    isActive,
    isNew: !isActive,
    location: timezone,
    nextId,
    start,
    theSameDay: startDate === endDate,
  } as any;
};

export const getRegularSchedule = value => {
  const timezone = value.location;
  const startTime = moment().tz(timezone);
  const endTime = startTime.clone().add(value.time, 'minutes');

  const dates: string[] = [];

  const startTemp = moment().tz(timezone);
  const endTemp = startTemp.clone().add(value.time, 'minutes');

  while (startTemp.startOf('day').isBefore(endTemp.endOf('day'))) {
    dates.push(startTemp.format('MM/DD/YYYY'));
    startTemp.add(1, 'day');
  }
  const schedules = dates.map((date, index) => {
    let start = '00:00';
    let end = '23:59';
    if (index === 0) {
      start = startTime.format('HH:mm');
    }
    if (index === dates.length - 1) {
      end = endTime.format('HH:mm');
    }
    return {
      nodeId: value.nextId,
      schedule: {
        type: ScheduleType.SCHEDULE_TYPE_DATE,
        schedule: {
          location: value.location,
          date,
          timeRanges: [{ start, end }],
        },
      },
    };
  });

  return schedules;
};

export const getIndefinitelySchedule = value => [
  {
    nodeId: value.nextId,
    schedule: {
      type: ScheduleType.SCHEDULE_TYPE_WEEKDAY,
      schedule: {
        location: value.location,
        daysOfTheWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        TimeRanges: [{ start: '00:00', end: '23:59' }],
      },
    },
  },
];
